import { Card, CardBody, Col } from "reactstrap";
import { MessageToastsTitle } from "../../../../Constants/Constants";
import { MessageToastsSubTitle } from "../../../../Data/BonusUi/Scrollable";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import ErrorToast from "./ErrorToast";
import SuccessToast from "./SuccessToast";
import WarningToast from "./WarningToast";

const MessageToasts = () => {
  return (
    <Col xs="12">
      <Card>
        <CommonCardHeader title={MessageToastsTitle} span={MessageToastsSubTitle} />
        <CardBody className="common-flex common-toasts">
          <SuccessToast />
          <WarningToast />
          <ErrorToast />
        </CardBody>
      </Card>
    </Col>
  );
};

export default MessageToasts;
